// extracted by mini-css-extract-plugin
export var container = "_2m-0";
export var error = "_2m-9";
export var label = "_2m-5";
export var light = "_2m-6";
export var md = "_2m-3";
export var sm = "_2m-2";
export var thin = "_2m-8";
export var thinBold = "_2m-7";
export var vertical = "_2m-4";
export var xs = "_2m-1";